import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dprTitle',
})
export class DprTitlePipe implements PipeTransform {
  transform(dprDisplayId: number): string {
    return ('0000' + dprDisplayId).slice(-4);
  }
}
